import { fromJS  } from 'immutable';

export const State = fromJS({
  isPosting: false,
  errMsg: '',
  reportName: '',
  rowList: [],
});